import {inject, observer} from 'mobx-react';
import React, {useContext} from 'react';
import styled from 'styled-components';
import {ThemeContext} from '../../../apiContexts';
import {DeviceInfoStyle} from '../styles';
import Actions from './actions';
import Driver from './driver';
import Header from './header';
import Location from './location';
import Contact from './contact';
import DeviceInfoAttributes from '../../../components/device-info-attributes';

const Style = styled.div`
  background-color: white;
  box-shadow: $shadow;
  pointer-events: all;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 10px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  height: 100%;
`;

const Hr = styled.hr`
  width: calc(100% - 2rem);
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const Container = styled.div`
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  height: 100%;
  position: absolute !important;
  z-index: 6;
  padding-bottom: 1.5rem;
`;

const DeviceDetail = ({
  selected = {},
  server,
  toggleTrace,
  trace,
  createGeofence,
  followToogle,
  follow,
  driver,
}) => {
  const {name, uniqueId, status, currentPosition = {}, attributes} = selected;
  const {timezone} = server.attributes;
  const theme = useContext(ThemeContext);

  return (
    <Container>
      <Style className="bg-white w-100 custom-shadow">
        <Header {...{...selected, theme}} server={server}/>
        <Contact contact={selected.contact} theme={theme}/>
        <Location
          theme={theme}
          currentPosition={currentPosition}
          timezone={timezone}
        />
        <Driver theme={theme} driver={driver}/>
        {/* <Pictures theme={theme}/> */}
        <Hr/>
        <DeviceInfo currentPosition={currentPosition} theme={theme} />
        <Hr/>
        <Actions
          traceToggle={toggleTrace}
          trace={trace}
          follow={follow}
          followToogle={followToogle}
          createGeofence={createGeofence}
        />
      </Style>
    </Container>
  );
};

const DeviceInfo = ({theme, currentPosition}) => (
  <DeviceInfoStyle id="deviceInfo" theme={theme}>
    <span>Informações do Dispositivo</span>
    <br/>
    <DeviceInfoAttributes currentPosition={currentPosition} theme={theme} />
  </DeviceInfoStyle>
);

const mapping = ({store}) => ({
  selected: store.events.currentDevice,
  server: store.server,
  map: store.map,
});

export default inject(mapping)(observer(DeviceDetail));
